
$( document ).ready(function() {

  //mobile toggle//
    $('.mobile-toggle i.icons').on("click", function () {
      $('.mobile-toggle i').removeClass('active');
      $(this).addClass('active');
      $('.hover-content1').stop().slideUp(200);
    $(this).next().stop().slideToggle(400);
  }); 
  
 //thumbnail toggle//
    $('#more-slides .item').on("click", function () {
      $('#more-slides .item').removeClass('active');
      $(this).addClass('active');
  }); 

  //mobile menu//
  $('.open-sidebar').on("click", function () {
    $(".offcanvas").css('width','250px');
    $("#main").css({'transform':'translatex(250px)', 'opacity':'0.4'});
    $(".overlay3").css({"opacity": "1", "width": "100%"});
  }); 
  $('.close-sidebar').on("click", function () {
    $(".offcanvas").css('width','0px');
    $("#main").css({'transform':'translatex(0px)', 'opacity':'1'});
    $(".overlay3").css({"opacity": "0", "width": "0%"});
  }); 


  //hot product
  $('.img').on("click", function () {
    var src = $(this).find('a').data('image');
    $('.img').removeClass('active');
    $(this).addClass('active');
    $('.single-image img').attr('src', src);
  }); 
  //faq
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    // Variables privadas
    var links = this.el.find('.link');
    // Evento
    links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
  }

  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
    $this = $(this),
      $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('open');

    if (!e.data.multiple) {
      $el.find('.submenu').not($next).slideUp().parent().removeClass('open');
    };
  }	

  var accordion = new Accordion($('#accordion'), false);
  
  //slider loader
  function load_slider(){
    $('.sh-slideshow .wrapper').hide();
  }
  setTimeout(load_slider, 1000);
  
  //tab loader
  $('.sh-products-tab .nav-tabs1 li').click(function(){
    var tab = $(this).find('a').data('id');  
    $('.sh-products-tab .nav-tabs1 li').removeClass('active');
    $(this).addClass('active');
    $('.tab-pane1').hide();
    $('#'+tab).show();
    setTimeout(function() { 
      $('#'+tab).find('.wrapper').hide();
    }, 1500);
  });  	
  
  var tab_height = $('.tab-content').height();
  //menu vertical
  var button_vertical = $('.header-bottom .menu-vertical-wrapper>h4');
  button_vertical.click(function(){
    $(this).next().slideToggle();
  });
  //slick

  $('.slider-single').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    adaptiveHeight: true,
    infinite: false,
    useTransform: true,
    speed: 400,
    cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
  });

  $('.configurable-swatch-list').each(function() {
    if ( $.trim( $(this).text() ).length == 0 ) {
      if ( $(this).children().length == 0 ) {
        $(this).hide();
      }
    }
  });

  $('.slider-nav')
  .on('init', function(event, slick) {
    $('.slider-nav .slick-slide.slick-current').addClass('is-active');
  })
  .slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    nav: true, centerPadding:'0px',
    centerMode: true,
    focusOnSelect: true,
    nextArrow: '<i class="zmdi zmdi-long-arrow-right"></i>',
    prevArrow: '<i class="zmdi zmdi-long-arrow-left"></i>',
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    }, {
      breakpoint: 640,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      }
    }, {
      breakpoint: 420,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    }]
  });

  $('.slider-single').on('afterChange', function(event, slick, currentSlide) {
    $('.slider-nav').slick('slickGoTo', currentSlide);
    var currrentNavSlideElem = '.slider-nav .slick-slide[data-slick-index="' + currentSlide + '"]';
    $('.slider-nav .slick-slide.is-active').removeClass('is-active');
    $(currrentNavSlideElem).addClass('is-active');
  });

  $('.slider-nav').on('click', '.slick-slide', function(event) {
    event.preventDefault();
    var goToSingleSlide = $(this).data('slick-index');

    $('.slider-single').slick('slickGoTo', goToSingleSlide);
  });  
  //deal
  $('[data-date]').each(function() {
    var $this = $(this), finalDate = $(this).data('date');
    $this.countdown(finalDate, function(event) {
      $this.html(event.strftime('<div class="deals-time day"><div class="num">%D</div><div class="title">days</div></div> <div class="deals-time hour"><div class="num">%H</div> <div class="title">hours</div></div><div class="deals-time minute"><div class="num">%M</div><div class="title">mins</div></div><div class="deals-time second"><div class="num">%S</div><div class="title">secs</div></div>'));
    });
  });  

  $('.widget-title i').click(function(){
    $('.categories-inner-page').slideToggle();
  });

  $('.t-tabs li').click(function(){
    $('.t-tabs li').removeClass("active");
    $(this).addClass("active");
    var div_show = $(this).data('id');
    $('.tab').fadeOut('400');
    $('#'+div_show).stop().fadeIn('600');
  });
  $('.menu-categories li .toggle').click(function(){
    $(this).next().slideToggle();
    $(this).prev().toggleClass('active-mobile-link');
    $(this).toggleClass('icon-minus');
    $(this).toggleClass('icon-plus');
  });
  $('.a.owl-carousel').owlCarousel({
    loop:true,
    items:1
  })
});
